<div>
    <form [formGroup]="userForm" style="min-height: 200px;">
        <div *ngIf="showForm">
            <div class="mb-4">
                <b>User Profile</b>
            </div>
            <div [ngClass]="isReadOnly ? 'page-layout' : 'modal-layout'">
                <mat-form-field class="form-field">
                    <mat-label>First Name</mat-label>
                    <input matInput formControlName='firstName' (focus)="onFieldFocus('firstName')" (blur)="onFieldBlur('firstName')">
                    <mat-error *ngIf="userForm.get('firstName').hasError('required') && userForm.get('firstName').touched">
                        <small>Required</small>
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="form-field">
                    <mat-label>Last Name</mat-label>
                    <input matInput formControlName='lastName' (focus)="onFieldFocus('lastName')" (blur)="onFieldBlur('lastName')">
                    <mat-error *ngIf="userForm.get('lastName').hasError('required') && userForm.get('lastName').touched">
                        <small>Required</small>
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="form-field">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName='email' (focus)="onFieldFocus('email')" (blur)="onFieldBlur('email')">
                    <mat-error *ngIf="userForm.get('email').hasError('required') && !userForm.get('email').hasError('email') && userForm.get('email').touched">
                        <small>Required</small>
                    </mat-error>
                    <mat-error *ngIf="userForm.get('email').touched && !userForm.get('email').hasError('required') && (userForm.get('email').hasError('email') || userForm.get('email').hasError('invalidDomain'))">
                        <small>Invalid email format</small>
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="form-field">
                    <mat-label>Role</mat-label>
                    <mat-select formControlName='userRoleId' (selectionChange)="onFieldBlur('userRoleId')">
                        <mat-option *ngFor="let role of roles" [value]="role.id">
                            {{ role.roleName }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="userForm.get('userRoleId').hasError('required')">
                        <small>Required</small>
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="form-field">
                    <mat-label>InContact User ID</mat-label>
                    <input matInput formControlName='agentId' (blur)="onFieldBlur('agentId')">
                </mat-form-field>
                <div class="mb-1 ms-1 mt-2" style="padding: 10px;">
                    <mat-slide-toggle formControlName="userActivated" (change)="toggleUserStatus($event)">
                        {{userStatusToggleLabel}}
                    </mat-slide-toggle>
                </div>
            </div>
        </div>
    </form>
</div>